import term from '@/api/term-semester'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  ac_status_id: [1, 3],
  edit_data: {},
  acYears: [],
  mainPrograms: [],
  subPrograms: [],
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  GET_AC_YEAR(state, data) {
    state.acYears = data
  },
  GET_MAIN_PROGRAM(state, data) {
    state.mainPrograms = data
  },
  GET_SUB_PROGRAM(state, data) {
    state.subPrograms = data
  },
  SET_STATUS_ID(state, value) {
    state.ac_status_id = value
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_EDIT_DATA(state, data) {
    let {
      ac_status,
      ac_status_id,
      acps,
      ac_year,
      branch,
      _deleting,
      _switching,
      ...resource
    } = data

    state.edit_data = resource
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true,
        filter: {
          ac_status_id: _.join(context.state.ac_status_id, ',')
        }
      },
      attributes
    )

    return term.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return term.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await term.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  update(context, data) {
    return term.update(data)
  },

  destroy(context, id) {
    return term.destroy(id)
  },

  async switchTerm(context, data) {
    return await term.switchTerm(data)
  },

  getTermOrder(context, data) {
    return term.getTermOrder(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.acYears.length > 0) {
      let response = await term.getAcYear()
      context.commit('GET_AC_YEAR', response)
    }

    if (!context.state.subPrograms.length > 0) {
      let response = await term.getSubProgram()
      context.commit('GET_SUB_PROGRAM', response)
    }

    if (!context.state.mainPrograms.length > 0) {
      let response = await term.getMainProgram()
      context.commit('GET_MAIN_PROGRAM', response)
    }
  },

  copyTerm(context, data) {
    return term.copyTerm(data)
  },
  getExistingTerm(context, attributes = {}) {
    const params = Object.assign(
      {
        page: -1
      },
      attributes
    )

    return term.get({ params })
  },
  getAcYearByBranch(context, branchId) {
    return term.getAcYear({ params: { branch_id: branchId } })
  }
}
